import { Route } from '@angular/router';
import { MainContentComponent } from '../main-content/main-content.component';

export const DirectoryOfDirectoriesListRoutes: Route[] = [
  {
    path: '',
    component: MainContentComponent,
  },
];
